import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "./axiosHelper";

// Login api
export const auththunk = createAsyncThunk('data/login',
    async(data)=>{
      const res = await axiosInstance.post('/api/v1/Login', data);
      return res.data
    }
)

//send email to generate OTP
export const emailSend = createAsyncThunk('data/email',
  async(data)=>{
    const res = await axiosInstance.post('/api/v1/emailSend', data);
      return res.data
  }
)

//Verify OTP
export const verifiedOtp = createAsyncThunk('data/verifiedOtp',
  async(data)=>{
    const res = await axiosInstance.post('/api/v1/verifyOtp', data);
      return res.data
  }
)

//Change Password
export const changePassword = createAsyncThunk('data/changePassword',
  async(data)=>{
    const res = await axiosInstance.post('/api/v1/changePassword', data);
      return res.data
  }
)

// Dispaly all notifications
export const getAllNotificationDetails = createAsyncThunk('data/getAllNotificationDetails',
  async(data)=>{
    const res = await axiosInstance.get(`/api/v1/getNotificationsByRecipientName/${data}`);    //getallnotificationdetails
    return res.data
  }
)
export const deleteSingleNotification = createAsyncThunk(
  'notification/deleteSingleNotification',
  async (id) => {
    const res = await axiosInstance.delete(`/api/v1/notifications/${id}`);
    return res.data;
  }
);
